<template>
  <div>
    <v-toolbar color="secondary" dark flat tile height="40px">
      <v-icon left>mdi-bank</v-icon>
      <v-toolbar-title class="cabecera">Información Bancaria</v-toolbar-title>
    </v-toolbar>
    <v-row no-gutters v-if="user.banco_n_cuenta && user.banco_n_cuenta != '-1'">
      <v-col cols="12" sm="4">
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="primary"> mdi-bank-circle</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-subtitle>Banco</v-list-item-subtitle>
            <v-list-item-title>
              {{ conv.capitalizeString(user.banco_nombre) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" sm="4">
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="primary"> mdi-bank-transfer </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-subtitle>Tipo de Cuenta</v-list-item-subtitle>
            <v-list-item-title>
              {{ conv.capitalizeString(user.banco_tipo_cuenta) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" sm="4">
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="primary"> mdi-numeric </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-subtitle>Número de cuenta</v-list-item-subtitle>
            <v-list-item-title>
              {{ conv.capitalizeString(user.banco_n_cuenta) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" class="text-center mt-4">
        No posee registro de cuenta bancaria.
      </v-col>
    </v-row>
  </div>
</template>

<script>
import conv from "@/utility/conversores";
export default {
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      conv
    };
  }
};
</script>

<style scoped>
.cabecera {
  color: white;
  font-weight: 300;
  font-size: 2.5vh;
  line-height: 3vh;
}
</style>
